// Copy and list data for the signed-out platform page. The capability ids double as the anchor
// targets the capability grid links to, so renaming one breaks a link.

export const CAPABILITIES = [
  {
    id: "programme-setup",
    title: "Programme setup",
    body: "Set up cohorts, roles, goals, access and programme agendas before anyone joins.",
    section: "design",
  },
  {
    id: "learning-journeys",
    title: "Learning journeys",
    body: "Turn each mentee's goal into a plan their mentor can work through with them.",
    section: "design",
  },
  {
    id: "mentor-matching",
    title: "Mentor matching",
    body: "Recommend mentors on goals, skills, experience, industry and availability.",
    section: "match",
  },
  {
    id: "session-management",
    title: "Session management",
    body: "Coordinate bookings, reminders, attendance and completed sessions without manual chasing.",
    section: "engage",
  },
  {
    id: "engagement-tracking",
    title: "Engagement tracking",
    body: "See who is active, where progress has stalled and who needs follow-up.",
    section: "engage",
  },
  {
    id: "ai-summaries",
    title: "AI session summaries",
    body: "Capture themes, takeaways, action items and next steps after each session.",
    section: "progress",
  },
  {
    id: "reports",
    title: "Reports and dashboards",
    body: "Pull engagement, feedback and goal progress into a report you can send upward.",
    section: "measure",
  },
] as const;

export const MATCH_CRITERIA = [
  "Development goals",
  "Skill alignment",
  "Industry relevance",
  "Experience level",
  "Availability",
  "Programme criteria",
] as const;

export const DESIGN_STEPS = [
  { title: "Onboard", body: "Invite participants and organise them by programme role." },
  { title: "Set the goal", body: "Capture what each mentee wants to achieve." },
  { title: "Generate the plan", body: "Create a guided journey the pair can work through together." },
] as const;

